export function isRequestError(response) {
  return Boolean(
    response?.response || response?.isAxiosError || response instanceof Error
  );
}

function normalizeErrorMessage(rawMessage) {
  if (!rawMessage) return null;
  if (typeof rawMessage === "string") return rawMessage;
  if (typeof rawMessage?.message === "string") return rawMessage.message;
  return null;
}

export function extractRequestErrorMessage(response, fallback) {
  const status = response?.response?.status;
  const upstreamMessage = normalizeErrorMessage(
    response?.response?.data?.error ||
      response?.response?.data?.message ||
      response?.message
  );
  if (status && upstreamMessage) {
    return `${fallback} (${status}): ${upstreamMessage}`;
  }
  return upstreamMessage || fallback;
}
